export default __webpack_public_path__ + "static/media/akamai.3933a452.svg";